import { Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

function ReviewCard({ r }) {
  return (
    <figure
      className="w-[320px] sm:w-[380px] shrink-0 rounded-2xl bg-white/[0.04] border border-cream/10 p-7"
      data-testid={`review-card-${r.id}`}
    >
      <div className="flex gap-1" aria-label={`${r.rating} étoiles sur 5`}>
        {Array.from({ length: 5 }).map((_, s) => (
          <Star key={s} className={`h-4 w-4 ${s < r.rating ? "fill-terra text-terra" : "text-cream/20"}`} />
        ))}
      </div>
      <blockquote className="mt-4 text-cream/80 text-base leading-relaxed">“{r.comment}”</blockquote>
      <figcaption className="mt-6 pt-5 border-t border-cream/10">
        <p className="font-semibold text-cream text-sm">{r.name}</p>
        {r.service && <p className="text-cream/50 text-sm mt-0.5">{r.service}</p>}
      </figcaption>
    </figure>
  );
}

export default function Reviews({ reviews }) {
  const allPlaceholders = reviews.length > 0 && reviews.every((r) => r.is_placeholder);

  // Répéter les avis pour remplir la piste et boucler sans rupture
  const filled = reviews.length > 0 ? Array.from({ length: Math.max(1, Math.ceil(6 / reviews.length)) }).flatMap(() => reviews) : [];
  const track = [...filled, ...filled];

  return (
    <section id="avis" data-testid="reviews-section" className="py-16 sm:py-24 bg-[#10180f] text-cream overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow light>Avis clients</Eyebrow>
          <h2 className="mt-3 font-display font-semibold tracking-tight leading-snug text-2xl sm:text-3xl lg:text-4xl text-cream" data-testid="reviews-title">
            Ils nous ont fait confiance
          </h2>
          {allPlaceholders && (
            <p className="mt-4 text-cream/50 text-sm max-w-xl">
              Exemples affichés en attendant les premiers avis clients — aucun témoignage fictif n'est présenté comme réel.
            </p>
          )}
        </Reveal>
      </div>

      {reviews.length === 0 ? (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mt-12 rounded-3xl border border-dashed border-cream/20 p-12 text-center text-cream/60" data-testid="reviews-empty">
            Les premiers avis clients seront publiés ici prochainement.
          </div>
        </div>
      ) : (
        <Reveal delay={0.1} className="mt-12">
          <div
            className="relative"
            data-testid="reviews-marquee"
            style={{
              maskImage: "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
              WebkitMaskImage: "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
            }}
          >
            <div className="flex w-max gap-5 pr-5 animate-[marquee_55s_linear_infinite] hover:[animation-play-state:paused] motion-reduce:animate-none">
              {track.map((r, i) => (
                <ReviewCard key={`${r.id}-${i}`} r={r} />
              ))}
            </div>
          </div>
        </Reveal>
      )}
    </section>
  );
}
